import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import { doReport } from "./utils";
var BASE_URL = "".concat(/^(http|https):$/.test(location.protocol) ? location.protocol : 'https:', "//btrace.qq.com/kvcollect");

var Boss = /*#__PURE__*/function () {
  function Boss(config) {
    _classCallCheck(this, Boss);

    this.config = config;
  }

  _createClass(Boss, [{
    key: "report",
    value: function report(params) {
      var url = this.buildReportUrl(params);
      doReport(url);
      return this;
    }
  }, {
    key: "buildReportUrl",
    value: function buildReportUrl(params) {
      var _this = this;

      var queryObj = Object.assign({}, this.config, params);
      var queryStr = Object.keys(queryObj).map(function (key) {
        var value = queryObj[key] + '';
        return _this.encodeDollor(key) + '=' + _this.encodeDollor(value);
      }).join('&');
      return BASE_URL + '?' + queryStr;
    }
  }, {
    key: "encodeDollor",
    value: function encodeDollor(content) {
      return content.replace(/\$/g, '|||');
    }
  }]);

  return Boss;
}();

export { Boss as default };